// extracted by mini-css-extract-plugin
export var alignLeft = "r_qq d_bG";
export var alignCenter = "r_bP d_bD";
export var alignRight = "r_qt d_bH";
export var textAlignLeft = "r_rk";
export var textAlignCenter = "r_rl";
export var textAlignRight = "r_rm";
export var hoursInnerWrapperAlt = "r_rn d_fb d_P d_Z d_bz d_bD d_bP d_dj";
export var hoursInnerWrapperLeft = "r_rp d_fc d_fb d_P d_Z d_bz d_bD d_bP d_b5 d_dj";
export var hoursText = "r_rq d_dw";
export var titleMargin = "r_rr d_cw";
export var hoursInnerInnerWrapper = "r_rs d_cz";